import React from 'react';
import moment from 'moment';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { Form, message } from 'antd';
import DspxModal from '../../../common/DspxModal/DspxModal';
import HouseAcceptanceNoticeForm from '../../forms/HouseAcceptanceNoticeForm/HouseAcceptanceNoticeForm';
import { texts } from '../../../../constants/texts';
import createAcceptance from '../../../../requests/createAcceptance';
import { fromDateStr, toDateStr } from '../../../../../../helpers/utcDate';
import { getQueryKeys } from '../../../../queries/queryKeys';

const HouseAcceptanceNoticeNode = ({ form, onCancel, ...props }) => {
  const { resetFields, validateFieldsAndScroll } = form;
  const currentHouse = useSelector(
    (state) => state.housingStockStore.currentHouse
  );

  const queryClient = useQueryClient();

  const handleCancel = () => {
    resetFields();
    onCancel();
  };

  const createAcceptanceMutation = useMutation(
    ({ values }) => createAcceptance(values),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          getQueryKeys.housingStockHouses({ houseId: currentHouse?.houseId })
        );
        message.success('Оповещение на приемку создано');
      },
    }
  );

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldValues) => {
      if (!err) {
        const {
          rangePicker: [from, to],
          includeWeekend,
          startTime,
          endTime,
          withLunchBreak,
          lunchStartTime,
          lunchEndTime,
          intervalId,
          workerIds,
          masterId,
        } = fieldValues;

        const values = {
          houseId: currentHouse?.houseId,
          intervalId,
          workerIds,
          masterId,
          fromDate: fromDateStr(from),
          toDate: toDateStr(to),
          includeWeekend: includeWeekend || false,
          startTime: moment(startTime).format('HH:mm'),
          endTime: moment(endTime).format('HH:mm'),
          withLunchBreak: withLunchBreak || false,
        };

        if (withLunchBreak) {
          values.lunchStartTime = moment(lunchStartTime).format('HH:mm');
          values.lunchEndTime = moment(lunchEndTime).format('HH:mm');
        }

        await createAcceptanceMutation.mutateAsync({ values });
        handleCancel();
      }
    });
  };

  return (
    <DspxModal
      {...props}
      title="Создание оповещения о приемке"
      destroyOnClose
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText={texts.create}
      width={500}
      confirmLoading={createAcceptanceMutation.isLoading}
      maskClosable={false}
    >
      <HouseAcceptanceNoticeForm form={form} />
    </DspxModal>
  );
};

const HouseAcceptanceNoticeModal = Form.create({
  name: 'house_acceptance_notice',
})(HouseAcceptanceNoticeNode);

export default HouseAcceptanceNoticeModal;
